export default __webpack_public_path__ + "static/media/1-3-1.2744111b.webp";